<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>订单号</span>
				<el-input :value="number" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>商品名称</span>
				<el-input :value="goodsName" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>价格</span>
				<el-input :value="price" disabled>
					<template slot="prepend">￥</template>
				</el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>数量</span>
				<el-input :value="num" disabled>
					<template slot="prepend">个</template>
				</el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>支付总额</span>
				<el-input :value="amount" disabled>
					<template slot="prepend">￥</template>
				</el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>收货地址</span>
				<el-input :value="addr" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>流水号</span>
				<div class="b_block" style="width: 200px;">
					<el-input :value="serial" disabled></el-input>
				</div>
				<div class="b_block" style="width: 70px;margin-left: 20px;">
					<el-button class="clipboard" type="primary" :data-clipboard-text="obj.serial">复制</el-button>
				</div>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>店铺名称</span>
				<el-input :value="shopName" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>购买账户</span>
				<el-input :value="uCode" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>支付类型</span>
				<el-input :value="payType" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>下单时间</span>
				<el-input :value="date" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>发货状态</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="sendStatus" disabled>
						<el-radio v-for="v in appSendStatus" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>订单状态</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="orderStatus" disabled>
						<el-radio v-for="v in appOrderStatus" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>滤波镜片</span>
				<el-input :value="level" disabled></el-input>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>近视镜片</span>
				<el-input :value="specification" disabled></el-input>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>镜架</span>
				<el-input :value="frame" disabled></el-input>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>增值服务</span>
				<el-input :value="valueAddedName" disabled></el-input>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row clear_both" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>屈光度数</span>
				<div class="b_block" style="width: 245px;margin-right: 23px;">
					<div style="font-size: 14px;line-height: 36px;">右眼</div>
					<el-input :value="refractionR" disabled></el-input>
				</div>
				<div class="b_block" style="width: 245px;">
					<div style="font-size: 14px;line-height: 36px;">左眼</div>
					<el-input :value="refractionL" disabled></el-input>
				</div>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row clear_both" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>散光</span>
				<div class="b_block" style="width: 245px;margin-right: 23px;">
					<div style="font-size: 14px;line-height: 36px;">右眼</div>
					<el-input :value="astigmatismR" disabled></el-input>
				</div>
				<div class="b_block" style="width: 245px;">
					<div style="font-size: 14px;line-height: 36px;">左眼</div>
					<el-input :value="astigmatismL" disabled></el-input>
				</div>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row clear_both" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>轴位</span>
				<div class="b_block" style="width: 245px;margin-right: 23px;">
					<div style="font-size: 14px;line-height: 36px;">右眼</div>
					<el-input :value="axialR" disabled></el-input>
				</div>
				<div class="b_block" style="width: 245px;">
					<div style="font-size: 14px;line-height: 36px;">左眼</div>
					<el-input :value="axialL" disabled></el-input>
				</div>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>瞳距</span>
				<el-input :value="distance" disabled></el-input>
			</div>
			
			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>训练师确认</span>
				<div class="b_checkbox_group">
					<el-radio-group :value="affirm" disabled>
						<el-radio :label="0">未确认</el-radio>
						<el-radio :label="1">确认</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.clipboardInstance = null;
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				goodsId: -1,
				number: '',
				goodsName: '',
				price: '',
				num: '',
				amount: '',
				addr: '',
				serial: '',
				shopName: '',
				uCode: '',
				payType: '',
				date: '',
				sendStatus: '',
				orderStatus: '',
				level: '',
				specification: '',
				frame: '',
				valueAddedName:'',
				refractionR: '',
				refractionL: '',
				astigmatismR: '',
				astigmatismL: '',
				axialR: '',
				axialL: '',
				distance: '',
				affirm: 0
			}
		},
		computed: {
			...mapState([
				'appSendStatus',
				'appOrderStatus'
			])
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				const that = this;
				that.$emit("changeDisplay", newVal);
				if (newVal) {
					that.loading = false;
					that.goodsId = that.obj.goodsId;
					that.number = that.obj.number;
					that.goodsName = that.obj.goodsName;
					that.price = that.obj.price;
					that.num = that.obj.num;
					that.amount = that.obj.amount;
					that.addr = that.obj.addr;
					that.serial = that.obj.serial;
					that.shopName = that.obj.shopName;
					that.uCode = that.obj.uCode;
					that.payType = that.obj.payTypeLabel;
					that.date = that.obj.time;
					that.sendStatus = that.obj.sendValue;
					that.orderStatus = that.obj.orderStatusValue;
					that.level = that.obj.level;
					that.specification = that.obj.specificationLabel;
					that.frame = that.obj.frameLabel;
					that.valueAddedName = that.obj.valueAddedName;
					that.refractionR = that.obj.refractionR;
					that.refractionL = that.obj.refractionL;
					that.astigmatismR = that.obj.astigmatismR;
					that.astigmatismL = that.obj.astigmatismL;
					that.axialR = that.obj.axialR;
					that.axialL = that.obj.axialL;
					that.distance = that.obj.distance;
					that.affirm = that.obj.affirm;
					that.clipboardInstance = new that.Clipboard('.clipboard');
					that.clipboardInstance.on('success', () => {
						that.$message.success('复制成功');
					});
				} else {
					that.clipboardInstance && that.clipboardInstance.destroy();
				}
			}
		}
	}
</script>

<style>
</style>
